import * as React from 'react';

import * as styles from './QuestionsAndAnswers.css';

export const QuestionsAndAnswers = ({ children }: React.PropsWithChildren) => {
  return (
    <div className={styles['questions-and-answers']}>
      <h2 className={styles['title']}>У&nbsp;вас&nbsp;вопросы&nbsp;— у&nbsp;нас&nbsp;ответы</h2>
      <div className={styles['container']}>{children}</div>
    </div>
  );
};
